import { render, staticRenderFns } from "./EditBeneficiaryRights.vue?vue&type=template&id=e8a0c616&"
import script from "./EditBeneficiaryRights.vue?vue&type=script&lang=js&"
export * from "./EditBeneficiaryRights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports